<rcp-modal-header [title]="title" />

<rcp-modal-content>
  <section>
    {{ description }}
  </section>

  @if (alert) {
    <section>
      <rcp-info-box color="alert">
        {{ alert }}
      </rcp-info-box>
    </section>
  }
</rcp-modal-content>

<rcp-modal-footer>
  <rcp-button-container [align]="hideCancelButton ? 'center' : 'space-between'">
    @if (cancelWithResult) {
      <rcp-button (click)="self.dismiss(false)">
        {{ cancelWithResultButtonText || ('qz-ignore-zm' | translate) }}
      </rcp-button>
    }

    <rcp-button-container align="right">
      @if (!hideCancelButton) {
        <rcp-button (click)="self.dismiss(null)">
          {{ cancelButtonText || ('qz-cancel-zm' | translate) }}
        </rcp-button>
      }

      <rcp-button (click)="self.dismiss(true)" [color]="confirmButtonClass">
        {{ confirmButtonText || ('qz-confirm-zm' | translate) }}
      </rcp-button>
    </rcp-button-container>
  </rcp-button-container>
</rcp-modal-footer>
